"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Checkbox = _interopRequireDefault(require("./Checkbox"));
var _useFormElementValidation = _interopRequireDefault(require("../../hooks/useFormElementValidation"));
var _useRandomId = _interopRequireDefault(require("../../hooks/useRandomId"));
var _useLabel2 = _interopRequireDefault(require("../../hooks/useLabel"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * The CheckboxGroup component offers a convenient way to display multiple Checkbox components
 */
var CheckboxGroup = function CheckboxGroup(props) {
  var useGroupControl = props.useGroupControl,
    options = props.options,
    checked = props.checked,
    controlledId = props.id,
    controlledName = props.name,
    initialLabel = props.label,
    helper = props.helper,
    inline = props.inline,
    displayAsButton = props.displayAsButton,
    checkboxesClassName = props.checkboxesClassName,
    checkboxClassName = props.checkboxClassName,
    size = props.size,
    _props$color = props.color,
    color = _props$color === void 0 ? 'primary' : _props$color,
    outline = props.outline,
    required = props.required,
    atLeast = props.atLeast,
    atMost = props.atMost,
    align = props.align,
    onChange = props.onChange,
    onError = props.onError,
    className = props.className;
  var checkboxGroupRef = _react.default.useRef();
  var id = _react.default.useRef((0, _useRandomId.default)(controlledId)).current;
  var name = controlledName || id;
  var _React$useState = _react.default.useState(checked || []),
    stateChecked = _React$useState[0],
    setChecked = _React$useState[1];
  var _React$useState2 = _react.default.useState(false),
    error = _React$useState2[0],
    setError = _React$useState2[1];
  var isInbetween = checked && options && checked.length && checked.length < options.length;
  var isAll = checked && options && checked.length === options.length;
  var _React$useState3 = _react.default.useState(isInbetween),
    isIndeterminate = _React$useState3[0],
    setIsIndeterminate = _React$useState3[1];
  var _React$useState4 = _react.default.useState(isAll),
    isAllChecked = _React$useState4[0],
    setIsAllChecked = _React$useState4[1];
  var _useFormElementValida = (0, _useFormElementValidation.default)(stateChecked, {
      required: required,
      atLeast: atLeast,
      atMost: atMost
    }),
    errors = _useFormElementValida[0],
    methods = _useFormElementValida[1];
  var _useLabel = (0, _useLabel2.default)(initialLabel, _extends({}, props, {
      id: id
    })),
    label = _useLabel.label;
  _react.default.useEffect(function () {
    var isInbetween = checked && options && checked.length && checked.length < options.length || options.filter(function (o) {
      return o.checked;
    }).length > 0;
    var isAll = checked && options && checked.length === options.length;
    setChecked(checked || []);
    setIsIndeterminate(isInbetween);
    setIsAllChecked(isAll);
  }, [checked, options]);
  _react.default.useEffect(function () {
    setError(errors.length > 0);
    if (typeof onError === 'function') {
      onError({
        name: name,
        errors: errors.length ? errors : []
      });
    }
  }, [errors, onError, name]);
  var handleChange = function handleChange(checkedCheckbox, ref, event) {
    if (useGroupControl) {
      var checkboxes = checkboxGroupRef.current.querySelectorAll("input");
      var checkall = checkboxGroupRef.current.querySelector("#" + id + "-checkall");
      var checkedCount = checkboxGroupRef.current.querySelectorAll("input:checked").length;
      checkall.checked = checkedCount > 0;
      checkall.indeterminate = checkedCount > 0 && checkedCount < checkboxes.length;
      setIsIndeterminate(checkall.indeterminate);
      setIsAllChecked(checkedCount === checkboxes.length);
    }
    var newStateChecked = [].concat(stateChecked);
    var checkboxId = event.target.id;
    if (checkedCheckbox) {
      newStateChecked.push(checkboxId);
    } else {
      newStateChecked = stateChecked.filter(function (value) {
        return value !== checkboxId;
      });
    }
    setChecked(newStateChecked);
    methods.onChangeCheckboxGroup(newStateChecked);
    if (typeof onChange === 'function') {
      onChange(newStateChecked);
    }
  };
  var handleChangeAll = function handleChangeAll(checkedCheckbox, ref, event) {
    setIsIndeterminate(false);
    setIsAllChecked(checkedCheckbox);
    var checkboxes = checkboxGroupRef.current.querySelectorAll("input");
    var checkall = checkboxGroupRef.current.querySelector("#" + id + "-checkall");
    checkall.checked = checkedCheckbox;
    checkall.indeterminate = false;
    var newStateChecked = [];
    if (checkedCheckbox) {
      for (var i = 0; i < checkboxes.length; i++) {
        var checkboxId = checkboxes[i].id;
        newStateChecked.push(checkboxId);
      }
    }
    for (var x = 0; x < checkboxes.length; x++) {
      checkboxes[x].checked = checkedCheckbox;
    }
    setChecked(newStateChecked);
    methods.onChangeCheckboxGroup(newStateChecked);
    if (typeof onChange === 'function') {
      onChange(newStateChecked, name, event);
    }
  };
  var handleBlur = function handleBlur() {
    return methods.onChangeCheckboxGroup(stateChecked);
  };
  var classes = (0, _clsx.default)('uk-checkbox-group', displayAsButton && 'uk-checkbox-group--display-buttons', useGroupControl && 'uk-checkbox-group-use-control', (helper.length > 0 || error) && 'has-helper', error && 'has-error', inline && 'checkbox-group--inline', className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes,
    ref: checkboxGroupRef
  }, useGroupControl ? /*#__PURE__*/_react.default.createElement(_Checkbox.default
  // className="uk-checkbox-group__label"
  , {
    align: align,
    checked: isAllChecked,
    isIndeterminate: isIndeterminate,
    id: id + "-checkall",
    name: id + "-checkall",
    onChange: handleChangeAll,
    color: color,
    size: size,
    outline: outline,
    displayAsButton: displayAsButton,
    label: label,
    "aria-describedby": (name || id) + "-helper-text"
  }) : label && /*#__PURE__*/_react.default.createElement("h3", {
    className: "uk-checkbox-group__label",
    id: id + "-checkall",
    "aria-describedby": (name || id) + "-helper-text"
  }, label), /*#__PURE__*/_react.default.createElement("div", {
    className: checkboxesClassName + " uk-checkbox-group__checkboxes",
    role: "group",
    "aria-labelledby": id + "-checkall"
  }, options.map(function (item, i) {
    return /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      align: align,
      key: i,
      name: item.name || name + "_" + i,
      id: item.id || id + "_" + i,
      label: item.label,
      checked: stateChecked.includes(item.id) || stateChecked.includes(id + "_" + i) || item.checked,
      disabled: item.disabled || false,
      onChange: handleChange,
      onBlur: handleBlur,
      color: color,
      size: size,
      outline: outline,
      value: item.value,
      className: checkboxClassName,
      displayAsButton: displayAsButton,
      inputClassName: useGroupControl ? id : ''
    });
  })), (helper.length > 0 || error) && /*#__PURE__*/_react.default.createElement("small", {
    className: "helper",
    id: (name || id) + "-helper-text"
  }, error ? errors : helper));
};
CheckboxGroup.propTypes = {
  /**
   * Use a checkbox in label section that manages all the checkboxes (using state indeterminate)
   */
  useGroupControl: _propTypes.default.bool,
  /**
   * Array of Checkboxes props
   */
  options: _propTypes.default.arrayOf(_propTypes.default.shape),
  /**
   * Ids of the Checkboxes to set as selected
   */
  checked: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])),
  /**
   * Prefix for the Checkboxes id (unless it has been set in the options prop)
   */
  id: _propTypes.default.string,
  /**
   * Prefix for the Checkboxes name (unless it has been set in the options prop)
   */
  name: _propTypes.default.string,
  /**
   * Label of the CheckboxeGroup
   */
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  /**
   * Layout of the CheckboxeGroup
   */
  inline: _propTypes.default.bool,
  /**
   * Change the display of the CheckboxeGroup
   */
  displayAsButton: _propTypes.default.bool,
  /**
   * ClassName to apply to each Checkbox
   */
  checkboxClassName: _propTypes.default.string,
  /**
   * ClassName to apply to checkboxes list
   */
  checkboxesClassName: _propTypes.default.string,
  /**
   * Size of the Checkboxes
   */
  size: _propTypes.default.oneOf(['tiny', 'small', 'default', 'large', 'big']),
  /**
   * Background-color of selected Checkboxes (or checkmark color if outline)
   */
  color: _propTypes.default.oneOf(['default', 'primary', 'secondary', 'success', 'alert', 'warning', 'white']),
  /**
   * Invert styling colors of the Checkboxes
   */
  outline: _propTypes.default.bool,
  /**
   * Helper text, is replaced by a message in case of error
   */
  helper: _propTypes.default.string,
  /**
   * Form-validation: set the CheckboxGroup as required
   */
  required: _propTypes.default.bool,
  /**
   * Form-validation: set the minimal number of Checkboxes that must be checked
   */
  atLeast: _propTypes.default.number,
  /**
   * Form-validation: set the maximal number of Checkboxes that can be checked
   */
  atMost: _propTypes.default.number,
  /**
   * Position of the Checkbox relative to its label
   */
  align: _propTypes.default.oneOf(['left', 'right']),
  /**
   * Callback function onChange
   */
  onChange: _propTypes.default.func,
  /**
   * Callback function onError
   */
  onError: _propTypes.default.func
};
CheckboxGroup.defaultProps = {
  useGroupControl: false,
  size: 'default',
  color: 'primary',
  outline: false,
  required: false,
  helper: '',
  checkboxesClassName: '',
  checkboxClassName: '',
  displayAsButton: false,
  align: 'left'
};
var _default = exports.default = CheckboxGroup;